/**
 * RiderTable Component
 * 라이더 현황 테이블 영역
 */
import React from 'react';
import Pagination from '@/shared/components/dataDisplay/Pagination';
import { Rider } from '../types/riderStatus.types';
import { TABLE_COLUMNS, TOTAL_COLUMN_COUNT, getDisplayValue, getRiderTypeName, formatBalance } from '../lib/riderStatusHelpers';

interface RiderTableProps {
    riders: Rider[];
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    onRiderClick: (riderId: string) => void;
    getContractBadge: (status: string) => React.ReactNode;
    getPrepaymentBadge: (isPrepayment: boolean) => React.ReactNode;
}

const RiderTable: React.FC<RiderTableProps> = ({
    riders,
    currentPage,
    totalPages,
    onPageChange,
    onRiderClick,
    getContractBadge,
    getPrepaymentBadge
}) => {
    /**
     * 셀 값 렌더링
     */
    const renderCellValue = (rider: Rider, columnKey: string): React.ReactNode => {
        switch (columnKey) {
            case 'id':
                return rider.id;
            case 'supplierName':
                return getDisplayValue(rider.supplierName);
            case 'name':
                return rider.name;
            case 'riderTypeName' :
                return getRiderTypeName(rider.riderType);
            case 'balAmt' :
                return formatBalance(rider.balAmt);
            case 'registNum' :
                return getDisplayValue(rider.registNum);
            case 'phoneNumber':
                return rider.phoneNumber;
            case 'preAcctYn':
                return getPrepaymentBadge(rider.preAcctYn === 'Y');
            case 'joinDate':
                return rider.joinDate;
            case 'contractEndDate':
                return getDisplayValue(rider.contractEndDate);
            default:
                return '-';
        }
    };

    return (
        <div className="card">
            <div className="card-body">
                <div className="table-container">
                    <table className="table">
                        <thead>
                            <tr>
                                {TABLE_COLUMNS.map(column => (
                                    <th key={column.key} className="text-center">
                                        {column.header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {riders.length === 0 ? (
                                <tr>
                                    <td colSpan={TOTAL_COLUMN_COUNT} className="empty-state">
                                        검색 결과가 없습니다.
                                    </td>
                                </tr>
                            ) : (
                                riders.map((rider, index) => (
                                    <tr
                                        key={rider.id || `rider-${index}`}
                                        className="rider-row-clickable"
                                        onClick={() => onRiderClick(rider.id)}
                                    >
                                        {TABLE_COLUMNS.map(column => (
                                            <td key={column.key} className="text-center">
                                                {renderCellValue(rider, column.key)}
                                            </td>
                                        ))}
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* 페이지네이션 */}
                <div className="pagination-container">
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={onPageChange}
                        maxPagesToShow={5}
                    />
                </div>
            </div>
        </div>
    );
};

export default RiderTable;
